module.exports = __webpack_public_path__ + "img/1.ba58f383.png";